import { Order } from "./types";

export const apiIds = ["005KB000000u5K6YAI", "0057R00000Ast0mQAB"];

export function descendingComparator<T>(a: T, b: T, orderBy: keyof T) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

export function getComparator<Key extends keyof any>(
  order: Order,
  orderBy: Key
): (a: { [key in Key]: number | string }, b: { [key in Key]: number | string }) => number {
  return order === "desc" ? (a, b) => descendingComparator(a, b, orderBy) : (a, b) => -descendingComparator(a, b, orderBy);
}

export function sortCaseFeedItemsByDate(items: any[]): any[] {
  return items.slice().sort((a, b) => {
    const dateA = new Date(a.LastModifiedDate);
    const dateB = new Date(b.LastModifiedDate);

    // Handle invalid dates (optional, but recommended)
    if (isNaN(dateA.getTime()) && isNaN(dateB.getTime())) {
      return 0; // Both are invalid, consider them equal.
    } else if (isNaN(dateA.getTime())) {
      return 1; // dateA is invalid, dateB is valid, dateB comes first.
    } else if (isNaN(dateB.getTime())) {
      return -1; // dateB is invalid, dateA is valid, dateA comes first.
    }

    return dateB.getTime() - dateA.getTime(); // Sort in descending order (latest first)
  });
}
